import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import HighchartsVue from 'highcharts-vue'

import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

import axios from 'axios'
import VueAxios from 'vue-axios'


//npm install devextreme@22.1 devextreme-vue@22.1 --save --save-exact
//import 'devextreme/dist/css/dx.light.css'
import './assets/css/dxgob.css'


import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
 
loadMessages(esMessages);
locale(navigator.language || navigator.browserLanguage)






axios.defaults.baseURL='http://presupuesto.haciendachiapas.gob.mx/sicope/api/api/';
//axios.defaults.baseURL = (process.env.NODE_ENV !== 'production') ? 'http://localhost:60870/api/' : (location.hostname.includes('a1cy9') ? 'http://a1cy9/sicope/api/api/':'http://presupuesto.haciendachiapas.gob.mx/sicope/api/api/')

// import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';

// createApp(App).use(Quasar, {
//     plugins: {
//         Notify
//     },
//     config: {
//         quasarUserOptions
//     }
//   }).use(store).use(router).mount('#app')



createApp(App).use(Quasar, quasarUserOptions).use(store).use(router).use(VueAxios,axios).use(HighchartsVue).mount('#app')



